import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-form-strip-data-card',
  templateUrl: './turns-form-strip-data-card.component.html',
  styleUrls: ['./turns-form-strip-data-card.component.scss']
})
export class TurnsFormStripDataCardComponent implements OnInit, OnChanges {

  @Input() form: FormBasic;
  basicDataForm = new FormGroup({
    intervalCapacity: new FormControl(1),
    intervalDuration: new FormControl(0),
    maxReservation: new FormControl(1),
    intervalOccupacityAlert: new FormControl(0),
    reservationForDay: new FormControl(false),
    showIntervalFormat: new FormControl(false)
  });
  updateFormuserDataInfoSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
    private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateFormuserDataInfoSubscription = this.formsTurnsService.updateFormStripDataInfo(this.form.InternalId, this.form.Active, this.basicDataForm.get('intervalCapacity').value, this.basicDataForm.get('intervalDuration').value, this.basicDataForm.get('maxReservation').value, this.basicDataForm.get('intervalOccupacityAlert').value, this.basicDataForm.get('reservationForDay').value).subscribe(
        (res) => {
          this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
          this.formsTurnsService.refreshForm();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public updateShowIntervalFormat() {
    const validation = this.validateForm();
    if (validation) {
      this.updateFormuserDataInfoSubscription = this.formsTurnsService.updateShowIntervalFormat(this.form.InternalId, this.basicDataForm.get('showIntervalFormat').value).subscribe(
        (res) => {
          this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
          this.formsTurnsService.refreshForm();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      intervalCapacity: this.form.IntervalCapacity,
      intervalDuration: this.form.IntervalDuration,
      maxReservation: this.form.MaxReservation,
      intervalOccupacityAlert: this.form.IntervalOccupacityAlert,
      reservationForDay: this.form.ReservationForDay,
      showIntervalFormat: this.form.ShowEndTime
    });
  }

  public validateForm() {
    return true;
  }
}
